<p-button
  size="small"
  type="button"
  [rounded]="true"
  icon="fas fa-bell"
  styleClass="relative overflow-visible"
  (click)="openDialog()"
  badgeClass="p-badge-danger absolute top-0 right-0 m-0 -mt-1 -mr-1 text-center"
  [badge]="unreadCount ? unreadCount + '' : ''"></p-button>

<p-dialog
  [(visible)]="displayDialog"
  [modal]="true"
  [style]="{ width: '80rem' }">
  <ng-template pTemplate="header">
    <app-header icon="fas fa-envelope" text="Benachrichtigungen"></app-header>
  </ng-template>
  <div class="grid">
    <div class="col-4">
      <p-panelMenu [model]="messageItems"></p-panelMenu>
    </div>
    <div class="col-8">
      @if (store.selectedItem(); as message) {
        <app-header
          [sub]="
            message.createdAt
              ? (message.createdAt * 1000 | date: 'dd.MM.yyyy') || ''
              : ''
          "
          styleClass="mt-0"
          icon="fas fa-envelope-open-text"
          [text]="message.title"></app-header>
        <p-scrollPanel [style]="{ width: '100%', height: '25rem' }">
          <div [innerHTML]="message.text"></div>
        </p-scrollPanel>
      } @else {
        wählen Sie links eine Nachricht aus
      }
    </div>
  </div>
  <p-divider />
  <footer class="flex align-items-center gap-3">
    <button
      pButton
      type="button"
      label="schließen"
      icon="fas fa-xmark"
      severity="secondary"
      [rounded]="true"
      [text]="true"
      (click)="closeDialog()"></button>

    <button
      class="ml-auto"
      pButton
      [rounded]="true"
      [disabled]="unreadCount <= 0"
      type="button"
      icon="fas fa-check-double"
      label="alle als gelesen markieren"
      (click)="markAllAsRead()"></button>
  </footer>
</p-dialog>
